import { isPhoneSize } from 'utils/util';
import { AccountingL1ByPaymentCompany } from './AccountingL1ByPaymentCompany';
import { USDollar } from 'utils/format';
import { GlobalContext } from 'GlobalContext';
import { useContext } from 'react';

export function AccountingHeader() {
    const { payoutTableColumnsToShow, payoutsColumns, payoutTableWidth } =
        useContext(GlobalContext);
    function HeaderItem(props) {
        const { columnName } = props;
        return (
            <>
                {payoutTableColumnsToShow[columnName] && (
                    <div
                        style={{
                            width: `${payoutsColumns[columnName]}px`,
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    >
                        {columnName}
                    </div>
                )}
            </>
        );
    }

    return (
        <div
            style={{
                display: 'inline-block',
                display: 'flex',
                width: `${payoutTableWidth + 40}px`,
                // borderBottom: '1px solid black',
            }}
        >
            <div
                style={{
                    width: '150px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Payment Company
            </div>

            <HeaderItem columnName={'Investment Entity'} />
            <HeaderItem columnName={'Investor'} />
            <HeaderItem columnName={'Fund'} />
            <HeaderItem columnName={'Start Date'} />
            <HeaderItem columnName={'End Date'} />
            <HeaderItem columnName={'Currency'} />
            <HeaderItem columnName={'Frequency'} />
            <HeaderItem columnName={'Interest'} />
            <HeaderItem columnName={'Invested Amount'} />
            <HeaderItem columnName={'Account Balance'} />
            <HeaderItem columnName={'Amount'} />
            <HeaderItem columnName={'Type'} />
            <HeaderItem columnName={'Next Payment Date'} />
            <HeaderItem columnName={'Next Payment Due'} />
            <HeaderItem columnName={'Status'} />
            <HeaderItem columnName={'Pay'} />
        </div>
    );
}

export function Accounting(props) {
    const {
        payoutsRaw,
        payouts,
        accountId2accountName,
        accountId2Investors,
        scrollSyncRef,
        transactionId2Status,
        timezoneOffset,
        handleStatusChange,
        accountId2Currency,
        backgroundColors,
    } = props;
    const uniquePaymentCompanyIds = [
        ...new Set(payoutsRaw.map((e) => e.payment_company_id)),
    ].sort();
    return (
        <>
            {payoutsRaw.length > 0 && (
                <div
                    ref={scrollSyncRef}
                    style={{
                        overflowY: 'auto',
                        maxHeight: isPhoneSize()
                            ? 'calc(100vh - 300px)'
                            : 'calc(100vh - 150px)',
                    }}
                >
                    <div>
                        {uniquePaymentCompanyIds.map(
                            (paymentCompanyId, idx) => {
                                return (
                                    <AccountingL1ByPaymentCompany
                                        companyBgBase={
                                            backgroundColors[idx % 2]
                                        }
                                        payouts={payoutsRaw.filter(
                                            (payout) =>
                                                payout.payment_company_id ===
                                                paymentCompanyId
                                        )}
                                        accountId2accountName={
                                            accountId2accountName
                                        }
                                        key={idx}
                                        isTop={idx === 0}
                                        accountId2Investors={
                                            accountId2Investors
                                        }
                                        transactionId2Status={
                                            transactionId2Status
                                        }
                                        timezoneOffset={timezoneOffset}
                                        handleStatusChange={handleStatusChange}
                                        accountId2Currency={accountId2Currency}
                                    />
                                );
                            }
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export function AccountingSummary(props) {
    const { totalInterestAmount } = props;
    const { payoutTableColumnsToShow, payoutsColumns, payoutTableWidth } =
        useContext(GlobalContext);

    function SummaryItem(props) {
        const { columnName } = props;
        return (
            <>
                {payoutTableColumnsToShow[columnName] && (
                    <div
                        style={{
                            width: `${payoutsColumns[columnName]}px`,
                            textAlign: 'center',
                            alignContent: 'center',
                        }}
                    ></div>
                )}
            </>
        );
    }

    return (
        <div
            style={{
                display: 'inline-block',
                display: 'flex',
                width: `${payoutTableWidth + 40}px`,
                // borderBottom: '1px solid black',
                // borderTop: '1px solid black',
            }}
        >
            <div
                style={{
                    width: '150px',
                    textAlign: 'center',
                    alignContent: 'center',
                }}
            >
                Sum
            </div>

            <SummaryItem columnName={'Investment Entity'} />
            <SummaryItem columnName={'Investor'} />
            <SummaryItem columnName={'Fund'} />
            <SummaryItem columnName={'Start Date'} />
            <SummaryItem columnName={'End Date'} />
            <SummaryItem columnName={'Currency'} />
            <SummaryItem columnName={'Frequency'} />
            <SummaryItem columnName={'Interest'} />
            <SummaryItem columnName={'Invested Amount'} />
            <SummaryItem columnName={'Account Balance'} />
            {payoutTableColumnsToShow['Amount'] && (
                <div
                    style={{
                        width: '100px',
                        textAlign: 'center',
                        alignContent: 'center',
                    }}
                >
                    {USDollar.format(totalInterestAmount)}
                </div>
            )}
            <SummaryItem columnName={'Type'} />
            <SummaryItem columnName={'Next Payment Date'} />
            <SummaryItem columnName={'Next Payment Due'} />
            <SummaryItem columnName={'Status'} />
            <SummaryItem columnName={'Pay'} />
        </div>
    );
}
